export interface Attivita {
  attivitaId: number;
  pianificaId: number;
  organizzazioneId: number;
  tipoAttivita: TipoAttivita;
  posizione: number;

  // Campi comuni
  idDocumento?: number;
  indirizzo?: string;
  citta?: string;
  cap?: string;
  provincia?: string;
  nazione?: string;
  latitudine?: number;
  longitudine?: number;
  statoGeo: StatoGeo;
  dataCreazione: Date;

  // Tipo: Libera
  descrizione?: string;

  // Tipo: OrdineCliente
  // Feature 071 (#2975): rimossi i 7 campi mirror — letti ora dallo snapshot notaJson via
  // ordineFromNotaJson() (vedi pianificazione/attivita-ordine.helper.ts).
  idRiga?: number;
  rifOrdine?: string;
  dataConsegna?: Date;

  // Tipo: OrdineProduzione (v2)
  idRigaLavorazione?: number;
  descrizioneOrdine?: string;

  notaJson?: string;

  hasErrors?: boolean;
  errorMessage?: string;
}

export interface Pianifica {
  pianificaId: number;
  organizzazioneId: number;
  tipo: TipoPianifica;
  nome: string;
  descrizione?: string;
  dataPrevista: Date;
  stato: StatoPianifica;
  numeroAttivita: number;
  dataCreazione: Date;
  dataModifica: Date;
  creatoDa?: string;
  modificatoDa?: string;
  attivita: Attivita[];

  hasErrors?: boolean;
  errorMessage?: string;
}

export interface PianificaFilterRequest {
  orgId: number;
  search?: string;
  tipo?: TipoPianifica;
  stato?: StatoPianifica;
  dataDal?: Date;
  dataAl?: Date;
  page: number;
  count: number;
  sortField: string;
  sortAsc: boolean;
}

export interface RiordinaAttivitaRequest {
  orgId: number;
  pianificaId: number;
  ordine: AttivitaPosizione[];
}

export interface AttivitaPosizione {
  attivitaId: number;
  posizione: number;
}

export interface CambiaStatoRequest {
  orgId: number;
  pianificaId: number;
  nuovoStato: StatoPianifica;
}

export interface PianificazioneStatistiche {
  ordiniPianificati: number;
  ordiniNonPianificati: number;
  ordiniCompletati: number;
  pianificheBozza: number;
  pianificheConfermate: number;
  pianificheInCorso: number;
  pianificheCompletate: number;
}

export enum TipoPianifica {
  Consegna = 0
}

export enum StatoPianifica {
  Bozza = 0,
  Confermata = 1,
  InCorso = 2,
  Completata = 3
}

export enum TipoAttivita {
  Libera = 0,
  OrdineCliente = 1,
  OrdineProduzione = 2
}

export enum StatoGeo {
  NonGeocodificata = 0,
  Geocodificata = 1,
  Errore = 2,
  NonApplicabile = 3
}
